import React, { useEffect, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Toolbar from '@material-ui/core/Toolbar'
import Grid from '@material-ui/core/Grid'
import { Menu, MenuItem, Typography } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useBookStore, useLoadBook } from '../Stores/BookStore'
import { RecentBookCover } from '../Components/RecentBookCover'
import { useRecentBooksStore } from '../Stores/RecentBooksStore'
import { useSchoolStore } from '../Stores/SchoolStore'
import SchoolDisconnectDialog from '../Components/SchoolDisconnectDialog'

import './CodeEntryPage.css'
import { SchoolConnectDialog } from '../Components/SchoolConnectDialog'

function Header() {
  const school = useSchoolStore((state) => state.school)
  const [schoolDialogOpen, setSchoolDialogOpen] = useState(false)

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <AppBar style={{ overflow: 'hidden' }} position="fixed">
      <Toolbar variant="dense">
        <Grid
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          spacing={1}
        >
          <Grid item>
            <img
              alt="Verlagslogo"
              src="/diko.png"
              style={{
                maxWidth: 100,
                borderRadius: '2px',
                backgroundColor: '#fafafa',
                marginTop: '4px',
              }}
            />
          </Grid>

          <Grid item>
            <Typography variant="h6">Digitale Hefte</Typography>
          </Grid>
          {school !== undefined && (
            <Grid
              item
              // className={classes.licenseText}
              style={{
                marginLeft: 'auto',
                userSelect: 'none',
                display: 'initial',
                cursor: 'pointer',
              }}
            >
              <Button className="menu-button" onClick={handleClick}>
                {school.name}
              </Button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                  onClick={() => {
                    handleClose()
                    setSchoolDialogOpen(true)
                  }}
                >
                  Schulverbindung Entfernen
                </MenuItem>
              </Menu>
            </Grid>
          )}
          {school === undefined && (
            <Grid
              item
              // className={classes.licenseText}
              style={{
                marginLeft: 'auto',
              }}
            >
              <Button className="menu-button" onClick={handleClick}>
                Schulverbindung
              </Button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                  onClick={() => {
                    handleClose()
                    setSchoolDialogOpen(true)
                  }}
                >
                  Mit Schule Verbinden
                </MenuItem>
              </Menu>
            </Grid>
          )}
          <SchoolDisconnectDialog
            open={school !== undefined && schoolDialogOpen}
            setOpen={setSchoolDialogOpen}
          />
          <SchoolConnectDialog
            open={school === undefined && schoolDialogOpen}
            setOpen={setSchoolDialogOpen}
          />
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

function CodeForm({ loadBook, localLoaded, setLocalLoaded }) {
  const prevCode = useBookStore((state) => state.license.code)
  const loaded = useBookStore((state) => state.loaded)
  const loading = useBookStore((state) => state.loading)
  const schoolLoading = useSchoolStore((state) => state.loading)

  const [code, setCode] = useState(prevCode)

  // Apply book code from URL, passed by BookViewPage
  useEffect(() => {
    if (!loaded && prevCode) loadBook(prevCode, setLocalLoaded)
  }, [prevCode, loaded])

  return (
    <Paper>
      <Grid
        container
        direction="column"
        spacing={2}
        justify="center"
        alignContent="center"
      >
        <Grid item lg>
          <TextField
            autoFocus
            size="medium"
            variant="filled"
            value={code.trim()}
            label="Heft-Code"
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            onChange={(e) => setCode(e.target.value.trim())}
          />
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            disabled={!code}
            onClick={() => loadBook(code, setLocalLoaded)}
          >
            Heft Öffnen
          </Button>
        </Grid>
      </Grid>
      <Backdrop
        style={{ zIndex: 99999999 }}
        open={loading || schoolLoading || localLoaded}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Paper>
  )
}

export function CodeEntryPage() {
  const [localLoaded, setLocalLoaded] = useState(false)
  const loadBook = useLoadBook()

  const recentBooks = useRecentBooksStore((state) => state.books)
  recentBooks.sort((a, b) => a.title.localeCompare(b.title))

  return (
    <div>
      <Header />
      <Toolbar variant="dense" />

      <Container style={{ paddingTop: 32 }}>
        <CodeForm
          localLoaded={localLoaded}
          setLocalLoaded={setLocalLoaded}
          loadBook={loadBook}
        />
      </Container>

      <Container style={{ paddingTop: 32 }}>
        <Paper>
          {recentBooks.length > 0 && (
            <Typography
              style={{ paddingBottom: 16, paddingTop: 8, textAlign: 'center' }}
              variant="h4"
            >
              Gespeicherte Hefte
            </Typography>
          )}
          <Grid container spacing={3} justify="center" alignContent="center">
            {recentBooks.map((b) => (
              <Grid item key={b.code}>
                <RecentBookCover
                  book={b}
                  onClick={() => loadBook(b.code, setLocalLoaded)}
                />
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </div>
  )
}
